import firebase from 'firebase'
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyDVxnJb_LcGphK0OCSSC4hgeDX9LlaGlgI',
  authDomain: 'annuaire-30a72.firebaseapp.com',
  databaseURL: 'https://annuaire-30a72.firebaseio.com',
  projectId: 'annuaire-30a72',
  storageBucket: 'annuaire-30a72.appspot.com',
  messagingSenderId: '1005614557480'
}

const firebaseInit = firebase.initializeApp(config)
export const db = firebase.firestore()
export const auth = firebase.auth()
export const storageRef = firebase.storage().ref()
export const imageRef = storageRef.child('images')



// WEBPACK FOOTER //
// ./src/firebase/index.js